<template>
	<div class="heart">
		<strong class="heart__counter">{{donations}}</strong>
		<span class="heart__copy">Messages Sent</span>
	</div>
</template>

<script>
export default {
	props: {
		donations: {
			type: Number,
			required: true,
			default: 0,
		},
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';
	.heart { display: flex; flex-direction: column; justify-content: center; .bottom-right(1vh,3vw,10); .size(550px, 280px); background: transparent url(../assets/images/ico-heart.svg) 0 0 no-repeat; color: white; text-align: center; .bold();
		&__counter { display: block; font-size: 75/16rem; }
		&__copy { display: block; font-size: 24/16rem; }
	}
</style>



// WEBPACK FOOTER //
// src/components/AppCounter.vue